export const apiConfigs = {
    baseURL : "https://newpanel.barsepar.com/api/",
};